import { showMedia } from "@/lib/content";
import { t } from "@/lib/i18n";
import Photo from "@/components/Photo";
import Reveal from "@/components/Reveal";

export default function WidePhoto({ content, isPreview }) {
  const img = content?.media?.wide;
  if (!showMedia(img, isPreview)) return null;
  return (
    <section className="relative" data-testid="home-wide-photo">
      <Photo img={img} isPreview={isPreview} sizes="100vw" className="h-[62vh] min-h-[360px] max-h-[760px]" badgeClass="top-4 left-4" />
      <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#13261C]/80 to-transparent pt-32 pb-10 sm:pb-14">
        <Reveal className="safe-x max-w-7xl mx-auto">
          <p className="font-serif italic text-2xl sm:text-4xl text-cream max-w-2xl leading-snug">{t("home.wideCaption")}</p>
        </Reveal>
      </div>
    </section>
  );
}
